<div class="black-overlay" *ngIf="showSpinner" [ngStyle]="{'background-color': bdColor}" [style.position]="fullScreen ? 'fixed' : 'absolute'">
  <div [class]="spinnerClass" [style.color]="color">
    <div *ngFor="let i of divArray"></div>
  </div>
  <div class="loading-text">
    <ng-content></ng-content>
  </div>
</div>